/* SLIDE 34 */

import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SubHeader from "shared/components/SubHeader";
import ButtonBot from "shared/components/ButtonBot";
import AppInput from "shared/components/AppInput";
import AppSelect from "shared/components/AppSelect";

const ParkingWorkDayBook = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState("사용자정보(01-002)");
  const [selectedOption2, setSelectedOption2] = useState("급지구분");

  const options = [
    { value: "사용자정보(01-002)", label: "사용자정보(01-002)" },
    { value: "사용자정보(01-001)", label: "사용자정보(01-001)" },
    { value: "사용자정보(01-003)", label: "사용자정보(01-003)" },
  ];

  const options2 = [
    { value: "급지구분", label: "급지구분" },
    { value: "급지구분2", label: "급지구분" },
    { value: "급지구분3", label: "급지구분" },
    { value: "급지구분4", label: "급지구분" },
  ];

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleChange2 = (e) => {
    setSelectedOption2(e.target.value);
  };
  // Check if this is an edit (data passed from previous page)
  const isEdit = location.state && location.state.parkingData;

  const [formData, setFormData] = useState({
    managementNumber: isEdit ? location.state.parkingData.managementNumber : "",
    parkingName: isEdit ? location.state.parkingData.parkingName : "",
    parkingSpaces: isEdit ? location.state.parkingData.parkingSpaces : "",
    price: isEdit ? location.state.parkingData.price : "1층",
    creationDate: isEdit ? location.state.parkingData.creationDate : "",
    editDate: isEdit ? location.state.parkingData.editDate : "",
  });

  const [showPopup, setShowPopup] = useState(false);
  const [discountItems, setDiscountItems] = useState([
    { id: 1, icon: "Icon", title: "20분/500원", selected: false },
    { id: 2, icon: "Icon", title: "1시간당/1,000원", selected: false },
    { id: 3, icon: "Icon", title: "3시간당/2,500원", selected: false },
  ]);
  const [newDiscount, setNewDiscount] = useState({
    name: "",
    amount: "0 원",
  });


  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleApply = () => {
    if (newDiscount.name && newDiscount.amount) {
      // Create new title using name and amount from form
      const newTitle = `${newDiscount.name}/${newDiscount.amount}`;

      // Create new discount item
      const newItem = {
        id: discountItems.length + 1,
        icon: "Icon",
        title: newTitle,
        selected: false,
      };
      setDiscountItems([...discountItems, newItem]);
      setNewDiscount({ name: "", amount: "0 원" });
    }

    setShowPopup(false);
  };

  const handleInputChangeDiscount = (e) => {
    const { name, value } = e.target;
    setNewDiscount({
      ...newDiscount,
      [name]: value,
    });
  };
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleAddOrUpdateParking = () => {
    const currentDate = getCurrentDate();

    // If this is a new creation, both creation date and edit date are the same
    // If this is an edit, only update the edit date
    const creationDate = isEdit ? formData.creationDate : currentDate;
    const editDate = currentDate;

    // Navigate to parking_setting_manager with the required data
    navigate("/parking_setting_manager", {
      state: {
        parkingName: formData.parkingName,
        managementNumber: formData.managementNumber,
        creationDate: creationDate,
        editDate: editDate,
      },
    });
  };
  const handleCancel = () => {
    navigate("/parking_setting_manager");
  };
  const handleYes = () => {
    // alert("successfully!");
    console.log("successfully!")
  };
  return (
    <div className="parking-status-container parking-attendance-container">
      <SubHeader>
        <div className={`sub-header-text w-full`}>
          <span className="htBold">11월 20일 근무조회</span>
        </div>
      </SubHeader>
      <div className="htContent">
        <AppSelect
          className="mt-25"
          label="근무장소"
          options={options}
          onChange={handleChange}
          value={options[0].value}
        ></AppSelect>

        <AppInput className="htBold" label="출근시각" placeholder="" />
        <AppInput className="htBold" label="출근메모" placeholder="" />
        <AppInput className="htBold" label="퇴근시각" placeholder="" />
        <AppInput className="htBold" label="퇴근메모" placeholder="" />

        <AppSelect
          className="mb25"
          label="근무장소"
          options={options2}
          onChange={handleChange}
          value={options2[0].value}
        ></AppSelect>

      </div>
      <div className="flex justify-between mn-text-bottom-attendance" style={{ padding: "20px" }}>
        <span>일 근무시간</span>
        <span style={{ color: "#222222", fontWeight: "700", fontSize: "15px" }}>8시간</span>
      </div>
      {showPopup && (
        <div className="popup-overlay-form">
          <div className="popup">
            <div className="input-section">
              <div className="input-title">할인정보 명칭</div>
              <div className="input-name">
                <input
                  type="text"
                  name="name"
                  value={newDiscount.name}
                  onChange={handleInputChangeDiscount}
                  placeholder="할인정보 명칭을 입력해주세요"
                />
              </div>
            </div>
            <div className="input-section">
              <div className="input-title pt-3">할인금액</div>
              <div className="amount">
                <input
                  type="text"
                  name="amount"
                  value={newDiscount.amount}
                  onChange={handleInputChangeDiscount}
                  placeholder="0 원"
                />
              </div>
            </div>

            <div className=" action-buttons">
              <button className=" delete-button" onClick={handleClosePopup}>
                닫기
              </button>
              <button className=" add-button" onClick={handleApply}>
                적용하기
              </button>
            </div>
          </div>
        </div>
      )}
      <ButtonBot textYes='저장하기' textNo='취소하기' handleYes={handleYes} handleNo={handleCancel} />
    </div>
  );
};

export default ParkingWorkDayBook;
